import { Typography } from "@mui/material";
import { CollapsibleTable, CollapsibleTableCell, DataAutomation } from "../CollapsibleTable";
import ScrollIndicatorsComp from "../ScrollIndicatorsComp/ScrollIndicatorsComp";
import { summaryHeaderStyle } from "./styled";

interface IStatsProps {
  jobsOrdered: number,
  jobsOrderedBeforeAvailCutoff: number,
  jobsOrderedAfterAvailCutoff: number,
}

interface IPhysicalSummaryTableProps {
  totalJobs: IStatsProps,
  filledWithDoaEmployees: IStatsProps,
  filledWithWalkIn: IStatsProps,
  shortages: IStatsProps,
}

export const PhysicalSummaryTable: React.FC<IPhysicalSummaryTableProps> = ({
  totalJobs, filledWithDoaEmployees, filledWithWalkIn, shortages
}) => {
  const physicalDispatchSummaryCols: CollapsibleTableCell[] = [
    'Jobs', 'Total Jobs Ordered', 'Jobs Ordered Before DOA Expiry Time', 'Jobs Ordered After DOA Expiry Time',
  ].map(title => ({ title }));

  const dataAutomation: DataAutomation = {
    header: "summary-cols",
    rows: "summary-rows",
    columns: [
      "jobs-col",
      "tot-ordered-col",
      "before-expiry-col",
      "after-expiry-col"
    ]
  }

  const physicalDispatchSummaryRows = [
    [
      <Typography>Total Jobs</Typography>,
      totalJobs.jobsOrdered,
      totalJobs.jobsOrderedBeforeAvailCutoff,
      totalJobs.jobsOrderedAfterAvailCutoff
    ],
    [
      <Typography sx={{ pl: 1 }}>- Filled with DOA Employees</Typography>,
      filledWithDoaEmployees.jobsOrdered,
      filledWithDoaEmployees.jobsOrderedBeforeAvailCutoff,
      filledWithDoaEmployees.jobsOrderedAfterAvailCutoff
    ],
    [
      <Typography sx={{ pl: 1 }}>- Filled with walk-ins</Typography>,
      filledWithWalkIn.jobsOrdered,
      filledWithWalkIn.jobsOrderedBeforeAvailCutoff,
      filledWithWalkIn.jobsOrderedAfterAvailCutoff
    ],
    [
      <Typography>Shortages</Typography>,
      shortages.jobsOrdered,
      shortages.jobsOrderedBeforeAvailCutoff,
      shortages.jobsOrderedAfterAvailCutoff
    ],
  ];

  return (
    <Typography
      sx={{ mt: 2, mb: 4 }} 
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >
      <ScrollIndicatorsComp>
        <Typography sx={{ ...summaryHeaderStyle, position: 'sticky', left: 0, }} data-automation="phys-disp-tbl-title">
          Physical Dispatch Summary
        </Typography>
        <CollapsibleTable
          size="custom"
          cols={physicalDispatchSummaryCols}
          rows={physicalDispatchSummaryRows}
          dataAutomation={dataAutomation}
          isOneLevel
        />
      </ScrollIndicatorsComp>
    </Typography>
  )
}